import { useSyncExternalStore } from "react";

let unreadCount = 0;
const listeners = new Set<() => void>();

export const setIntercomUnreadCount = (count: number) => {
  unreadCount = count;
  listeners.forEach((listener) => listener());
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const useIntercomUnreadCount = (): number => useSyncExternalStore(subscribe, () => unreadCount);
